/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
        'jquery',
        'scrollStop',
        'domReady!'
    ], function($, scrollStop){
        "use strict";

        const $brandLogo    = $('.amshopby-option-link'),
            parentElement = '.column.main',
            childElement  = '.product-info-main',
            slideElement  = '.product-info-top-extra';

        // Move brand logo
        if($brandLogo.length) {
            $brandLogo.appendTo('.product-info-top-extra');
        }

        // Hide the short desc when the .product-info-main becomes sticky, only when element is (mostly) empty
        if($(childElement).css('position') === 'sticky' && $(slideElement).text().length > 2) {
            scrollStop(function () {
                if ($(parentElement).offset().top - $(childElement).offset().top < -10) {
                    $(slideElement + ':visible:not(.animating)').addClass('animating').slideUp(200, function () {
                        $(this).removeClass('animating');
                    });
                } else {
                    $(slideElement + ':hidden:not(.animating)').addClass('animating').slideDown(100, function () {
                        $(this).removeClass('animating');
                    });
                }
            })
        }
    }
);
